function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_61799",
  "data-name": "Path 61799",
  d: "M5.5,5.762A.762.762,0,0,1,6.262,5H9.31a.762.762,0,0,1,0,1.524H7.024v.762h1.27a.762.762,0,0,1,0,1.524H7.024v.762H9.31a.762.762,0,0,1,0,1.524H6.262a.762.762,0,0,1-.762-.762Z",
  transform: "translate(-2.452 -0.429)",
  fill: "#ff0031",
  fillRule: "evenodd"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_32509",
  "data-name": "Group 32509"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_61800",
  "data-name": "Path 61800",
  d: "M9.339,5.128a.762.762,0,0,1,1.057.211l.89,1.335.89-1.335a.762.762,0,1,1,1.268.845L12.2,8.048l1.242,1.863a.762.762,0,1,1-1.268.845l-.89-1.335-.89,1.335a.762.762,0,1,1-1.268-.845L10.37,8.048,9.128,6.185a.762.762,0,0,1,.211-1.057ZM15.857,5a.762.762,0,0,1,.762.762v4.571a.762.762,0,1,1-1.524,0V5.762A.762.762,0,0,1,15.857,5Zm1.524.762A.762.762,0,0,1,18.143,5h4.571a.762.762,0,1,1,0,1.524H21.191v3.81a.762.762,0,0,1-1.524,0V6.524H18.143a.762.762,0,0,1-.762-.762Z",
  transform: "translate(-0.619 -0.429)",
  fill: "#ff0031",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_61801",
  "data-name": "Path 61801",
  d: "M5.786,17.238A2.286,2.286,0,0,1,3.5,14.952V4.286A2.286,2.286,0,0,1,5.786,2H27.119A2.286,2.286,0,0,1,29.4,4.286V14.952a2.286,2.286,0,0,1-2.286,2.286Zm-.762-2.286a.762.762,0,0,0,.762.762H27.119a.762.762,0,0,0,.762-.762V4.286a.762.762,0,0,0-.762-.762H5.786a.762.762,0,0,0-.762.762Zm13.525,5.4a.762.762,0,0,0-.453.7v2.9H8.272a1.867,1.867,0,0,0-1.724,1.981v2.438a1.867,1.867,0,0,0,1.724,1.981H18.1v2.9a.762.762,0,0,0,1.273.565l6.737-6.1a.762.762,0,0,0,0-1.13l-6.737-6.1a.762.762,0,0,0-.82-.131Z",
  transform: "translate(-3.5 -2)",
  fill: "#ff0031",
  fillRule: "evenodd"
}));

function SvgExitAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "exit-alert",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.9,
    height: 32.014,
    viewBox: "0 0 25.9 32.014",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitAlert);
export default __webpack_public_path__ + "static/media/exit-alert.6d09557f.svg";
export { ForwardRef as ReactComponent };